import { useMutation } from 'react-query';
import { FairMarketValueConfigurationService } from '../../services/wealthlane-award-services';
import { CommaFormattedDecimal, CommaFormattedFloatPost } from '../../utils/global';

const useGetFMVconfigMarketPrice = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  awardType: string
): any => {
  return useMutation(
    async (payload: any) => {
      if (payload?.date) {
        return await handleRequest(
          FairMarketValueConfigurationService.getApiAwardApiAppFairMarketValueConfigurationMarketPrice(
            awardType,
            payload?.date
          )
        );
      }
    },
    {
      onSuccess: (response: any, context: any) => {
        context?.setFieldValue(
          `employee.${context?.index}.marketValueAtGrant`,
          CommaFormattedDecimal(response?.fmv === null ? '' : response?.fmv)
        );
        context?.setFieldValue(
          `employee.${context?.index}.grantPrice`,
          +CommaFormattedFloatPost(
            (response?.fmv * context?.issuedUnits.replaceAll(',', '')).toString()
          )
        );
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useGetFMVconfigMarketPrice;
